var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowUpRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M239.976 63.91 240 175.84c0 6.594-5.343 11.938-11.937 11.937l-18.335-.004c-6.594-.002-11.94-5.348-11.942-11.943l-.014-65.444L71.073 237.084c-3.888 3.888-10.19 3.888-14.079 0l-14.078-14.079c-3.888-3.887-3.888-10.19 0-14.078L169.614 82.228l-65.444-.014c-6.595-.001-11.942-5.348-11.943-11.943l-.004-18.334C92.222 45.343 97.566 40 104.161 40l111.929.024c13.188.004 23.882 10.698 23.886 23.886"
})));
export default SvgArrowUpRight;